export default __webpack_public_path__ + "static/media/BLR.479b813c.svg";